import React from 'react';
import { Box, Button, Typography } from '@p81-common/ui';
import { links } from '../../../../../../data/constants';
import { WarningAttentionBox } from '../ui';
import { createClasses } from './styles';

interface CompletionScreenBaseProps {
  title: string;
  body: string;
  actionLabel: string;
  warning?: { title: string; subtitle?: string };
}

// The CTA must do something - callers provide exactly one of the two actions.
type CompletionScreenProps = CompletionScreenBaseProps &
  (
    | {
        /** The action button opens this URL in a new tab. */
        actionHref: string;
        onAction?: never;
      }
    | {
        /** Called on action click (e.g. Done - close the sidebar). */
        onAction: () => void;
        actionHref?: never;
      }
  );

const CompletionScreen = ({
  title,
  body,
  actionLabel,
  actionHref,
  onAction,
  warning
}: CompletionScreenProps) => {
  const classes = createClasses();

  const handleAction = () => {
    if (actionHref) {
      window.open(actionHref, '_blank', 'noopener,noreferrer');
      return;
    }
    onAction?.();
  };

  return (
    <Box className={classes.container}>
      {warning && (
        <WarningAttentionBox
          title={warning.title}
          subtitle={warning.subtitle}
        />
      )}
      <img
        className={classes.image}
        src={`${links.imagesBaseUrl}/png/illus_InfinityPOrtal.png`}
        alt=""
      />
      <Typography variant="subtitle1" className={classes.title}>
        {title}
      </Typography>
      <Typography variant="body2" className={classes.body}>
        {body}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        className={classes.actionButton}
        onClick={handleAction}
      >
        {actionLabel}
      </Button>
    </Box>
  );
};

export default CompletionScreen;
